// ABOUTME: Route for /facility/shifts/$shiftId.
// ABOUTME: Loader prefetches shift detail, conversations, and forms on hover.

import ShiftDetailPage from "@/components/facility/ShiftDetailPage";
import { authedFetch } from "@/lib/authedFetch";
import { queryClient } from "@/lib/queryClient";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/facility/shifts/$shiftId",
)({
  loader: ({ params: { shiftId } }) => {
    queryClient.ensureQueryData({
      queryKey: ["shift-detail", shiftId],
      queryFn: () => authedFetch(`/api/shifts/${shiftId}`),
      staleTime: 30_000,
    });
    queryClient.ensureQueryData({
      queryKey: ["shift-conversations", shiftId],
      queryFn: () => authedFetch(`/api/shifts/${shiftId}/conversations`),
      staleTime: 30_000,
    });
    queryClient.ensureQueryData({
      queryKey: ["shift-forms", shiftId],
      queryFn: () => authedFetch(`/api/shifts/${shiftId}/forms`),
      staleTime: 30_000,
    });
  },
  component: ShiftDetailPage,
});
